module.exports = __webpack_public_path__ + "4dac705158fb1ca226d583b3829f82a0.ttf";